@let $multiState = multiState();
@let $state = panelState();

<aside
  #sidePanel
  class="mbs-sidepanel"
  [ngClass]="sidebarSideClass()">
  @if ($multiState && isExpanded()) {
    <div class="row g-0 h-100">
      @if ($state === PanelState.Precolumn) {
        <div class="col-3 col-xxl-2 h-100">
          <div class="mbs-sidepanel_pre-column-content p-3">
            <ng-content select="[pre-column]" />
          </div>
        </div>
      }
      <div
        class="h-100"
        [class]="$state === PanelState.Precolumn ? 'col-9 col-xxl-10' : 'col-12'">
        <ng-container [ngTemplateOutlet]="mainContentTemplate" />
      </div>
    </div>
  } @else {
    <ng-container [ngTemplateOutlet]="mainContentTemplate" />
  }
</aside>

<ng-template #mainContentTemplate>
  <header
    #headerEl
    class="mbs-sidepanel_header"
    [ngClass]="headerClass">
    <!-- Row -->
    <div class="mbs-sidepanel_header-row row">
      <div class="mbs-sidepanel_header-content col">
        <ng-template #headerTitle>
          <ng-content select="[header-title]" />
        </ng-template>

        <ng-template #loadingDataTitle>
          <ng-content select="[loading-data-title]" />
        </ng-template>

        <ng-container [ngTemplateOutlet]="loadingData ? loadingDataTitle : headerTitle" />
      </div>

      @if (showExpandedCross) {
        <div class="mbs-sidepanel_header-controls col-auto">
          <mbs-button
            [customClasses]="'mbs-sidepanel_ctrl'"
            [icon]="headerIcon()"
            [isCtrl]="true"
            [type]="'dark'"
            (click)="handleHeaderAction()" />
        </div>
      }

      @if (showCloseIcon) {
        <div class="mbs-sidepanel_header-controls col-auto">
          <mbs-button
            [customClasses]="'mbs-sidepanel_ctrl'"
            [icon]="'ico ico-Close'"
            [isCtrl]="true"
            [type]="'dark'"
            (click)="handleClose()" />
        </div>
      }
    </div>
    <!-- /Row -->

    <ng-content select="[header-content]" />
  </header>

  <div
    class="mbs-sidepanel_content"
    [class.mbs-form]="innerContentType !== 'inner'"
    [style.height]="contentHeight()">
    <ng-template #body>
      <ng-content select="[body]" />
    </ng-template>

    @if (innerContentType === 'tabs') {
      <ng-container [ngTemplateOutlet]="body" />
    } @else {
      @if (loadingData) {
        <mbs-loader class="mbs-sidepanel_content-loader" />
      } @else {
        <div class="mbs-sidepanel_content-scrolling">
          @if (innerContentType === 'nowrap') {
            <ng-container [ngTemplateOutlet]="body" />
          } @else {
            <div [class]="innerContentType === 'inner' ? 'mbs-sidepanel_content-inner' : 'mbs-form_content'">
              <ng-container [ngTemplateOutlet]="body" />
            </div>
          }
        </div>
      }
    }

    @if (showFooter) {
      <footer class="mbs-sidepanel_footer">
        <div
          class="mbs-sidepanel_footer-row"
          [class]="[!isCreate && showDelete ? 'justify-content-between' : 'justify-content-end']">
          <ng-template #footerDefault>
            @if (!isCreate && showDelete) {
              <div
                class="mbs-sidepanel_footer-col"
                [ngbTooltip]="deleteButtonTooltip"
                [placement]="deleteButtonTooltipPosition">
                <mbs-button
                  [disabled]="disabledDelete || loadingData"
                  [loading]="loadingForDelete$ | async"
                  [type]="'outline-danger'"
                  (click)="deleteEvent.emit()">
                  {{ actionNames.delete || 'Delete' }}
                </mbs-button>
              </div>
            }

            <div class="d-flex">
              @if (!hideSave) {
                <div
                  class="mbs-sidepanel_footer-col"
                  [ngbTooltip]="saveButtonTooltip"
                  [placement]="saveButtonTooltipPosition">
                  <mbs-button
                    [disabled]="disabledSave() || loadingData"
                    [loading]="loadingForSave$ | async"
                    [type]="'primary'"
                    (click)="saveEvent.emit()">
                    {{ actionNames.save ? actionNames.save : !isCreate ? 'Save' : 'Create' }}
                  </mbs-button>
                </div>
              }

              <div class="mbs-sidepanel_footer-col">
                <mbs-button
                  [type]="'secondary'"
                  (click)="panelClosed.emit()">
                  {{ actionNames.close || 'Close' }}
                </mbs-button>
              </div>
            </div>
          </ng-template>

          <ng-container [ngTemplateOutlet]="footerTemplateContent ? footerTemplateContent : footerDefault" />
        </div>
      </footer>
    }
  </div>
</ng-template>
